var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 2.5H3.33317C2.414 2.5 1.6665 3.2475 1.6665 4.16667V13.3333C1.6665 14.2525 2.414 15 3.33317 15H9.1665V16.6667H6.6665V18.3333H13.3332V16.6667H10.8332V15H16.6665C17.5857 15 18.3332 14.2525 18.3332 13.3333V4.16667C18.3332 3.2475 17.5857 2.5 16.6665 2.5ZM3.33317 11.6667V4.16667H16.6665L16.6682 11.6667H3.33317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.28a70ca94ed5a9d07475a026d59a4361.svg";
export { ForwardRef as ReactComponent };